import * as React from "react";
import { Formik, ErrorMessage } from "formik";
import { Row, Col, Alert, Button } from "reactstrap";
import PageLayout from "../components/PageLayout";
import ValidationSummary from "./ValidationSummary";
import { useParams, useHistory } from "react-router-dom";
import Loading from "./Loading";
import { useAuth0 } from "../auth/react-auth0-wrapper";
import { getUrlParameter } from "../utils/history"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const EditorContainer = ({
  schema,
  children,
  onCreate,
  onUpdate,
  onLoad,
  readOnly,
  redirRoot,
  title,
  inValues,
  renderOther,
  renderDealer,
  optionalNav,
  onInit,
  asSelector,
  canSave, noSaveBtn
}) => {
  const { onSuccess } = useAuth0();
  const { id } = useParams();
  const { push } = useHistory();
  const isEdit = id && !asSelector ? true : false;
  const [loading, setLoading] = React.useState(true);
  const [initialValues, setInitialValues] = React.useState(inValues || {});
  const returnTo = getUrlParameter("returnTo");

  React.useEffect(() => {
    loadData();
  }, [id || -1]);

  const loadData = async () => {
    try {
      setLoading(true);
      if (onInit) { await onInit(); }
      if (!id || asSelector) return;
      const item = await onLoad(id);
      setInitialValues(item);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onConfirm = async (entity, actions) => {
    actions.setStatus({
      msg: ""
    });
    actions.setSubmitting(true);
    try {
      if (!isEdit) {
        const result = await onCreate(entity);
        if (result === false) return;
        push(returnTo ? returnTo : redirRoot, { entity: result });
        console.log(result._id);
      } else {
        await onUpdate(entity);

        push(returnTo ? returnTo : redirRoot, { entity });
      }

      onSuccess();
    } catch (error) {
      //console.log(error)
      actions.setStatus({
        msg: "Errore durante il salvataggio! Si prega di riprovare."
      });
    } finally {
      actions.setSubmitting(false);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onConfirm}
      render={frmProps => {
        const containerHandleChange = (id, e) => {
          frmProps.handleChange({
            target: {
              id,
              value: e.target ? e.target.value : e.value,
              text:
                e.originalEvent && e.originalEvent.currentTarget
                  ? e.originalEvent.currentTarget.innerText
                  : e.value
            }
          });
        };
        return (
          <PageLayout
            optionalNav={optionalNav}
            title={title(frmProps.values)}
          >
            {renderDealer && renderDealer(frmProps)}
            {!readOnly && (
              <Row>
                <Col>
                  <ValidationSummary errors={frmProps.errors} />
                </Col>
              </Row>
            )}
            {children(frmProps, containerHandleChange, setLoading, loadData)}
            {!readOnly && (
              <Row>
                <Col>
                  <div className="float-right mt-2">
                    <Button
                      className="mr-2 mb-2"
                      color="warning"
                      disabled={frmProps.isSubmitting}
                      onClick={() => {
                        history.go(-1);
                        /* push(returnTo ? returnTo : redirRoot); */
                      }}
                    >
                      <FontAwesomeIcon icon="reply" /> Torna
                    </Button>

                    {canSave && !noSaveBtn && <Button
                      className="mr-2 mb-2"
                      color="success"
                      disabled={frmProps.isSubmitting}
                      onClick={frmProps.handleSubmit}
                    >
                      <FontAwesomeIcon spin={frmProps.isSubmitting ? true : false} icon={
                        frmProps.isSubmitting
                          ? "sync-alt"
                          : "check"
                      } /> Salva
                        </Button>
                    }
                  </div>
                </Col>
              </Row>
            )}
            {frmProps.status && frmProps.status.msg && (
              <Row>
                <Col>
                  <Alert color="danger">{frmProps.status.msg}</Alert>
                </Col>
              </Row>
            )}
            {renderOther && renderOther(frmProps)}
          </PageLayout>
        );
      }}
    />
  );
};

export default EditorContainer;
